import { render, staticRenderFns } from "./FeedbackManageView.vue?vue&type=template&id=73aa0eef&scoped=true"
import script from "./FeedbackManageView.vue?vue&type=script&lang=js"
export * from "./FeedbackManageView.vue?vue&type=script&lang=js"
import style0 from "./FeedbackManageView.vue?vue&type=style&index=0&id=73aa0eef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aa0eef",
  null
  
)

export default component.exports